import Header from "@components/pages/index/header"
import SEO from "@components/seo"
import config from "@config"
import navLogoImg from "@images/2x/4aa.png"
import countDownImg from "@images/themepublish.png"
import flowImg from "@images/update0511/43aa.png"
import flowSmImg from "@images/update0511/44aa.png"
import Nav from "@src/components/nav"
import Flow from "@src/components/pages/index/flow"
import GamesPrepare from "@src/components/pages/index/gamesPrepare"
import Rules from "@src/components/pages/index/rules"
import SideAnimationContainer from "@src/components/sideAnimationContainer"
import Tabs from "@src/components/tabs"
import { useAppContext } from "@src/context"
import classnames from "@src/utils/classnames"
import React, { useRef } from "react"
import * as styles from "./index.module.scss"

const TABS = [
  { key: "flow", title: "参与流程" },
  { key: "rules", title: "详细规则" },
  { key: "games", title: "游戏库" },
]

const renderBody = (key) => {
  switch (key) {
    case "flow":
      return <Flow />
    case "rules":
      return <Rules />
    case "games":
      return <GamesPrepare />
    default:
      break
  }
}

const IndexPage = () => {
  const { renderItem } = useAppContext()
  const upRef = useRef()

  return (
    <>
      <Nav
        showWhenRef={upRef}
        logo={navLogoImg}
        buttonProps={{
          to: "/games",
          children: "下载试玩",
        }}
      />
      <SEO />
      <Header />
      <SideAnimationContainer direction="left">
        <div className={styles.container}>
          <div className={styles.detail} ref={upRef}>
            <div className="text-center">
              <h3 style={{ marginBottom: 20 }}>开发主题公布</h3>
              <p>请自由地翻译下面这句短语，并从中收获你的灵感</p>
              <img src={countDownImg} alt="" className={styles.countDown} />
            </div>
            <div className={styles.music}>
              <iframe
                title="wangyiyun"
                frameborder="no"
                framespacing="0"
                border="0"
                marginwidth="0"
                marginheight="0"
                width="330"
                height="86"
                src="//music.163.com/outchain/player?type=2&amp;id=21257389&amp;auto=0&amp;height=66"
              />
              <div>（以上歌曲并不是题目，仅做为思考BGM）</div>
            </div>
            <p>
              Take me somewhere nice，在 Mogwai 的歌曲中一起灵魂漫游吧；
              <br /> Have a nice trip, Everyone～
            </p>
            <p>
              请根据以上主题进行游戏开发，然后在4月17日前（延长至5月4日24点前）在
              BOOOM
              的官方网站提交可运行的游戏项目，所有提交的游戏将会进行2次展示：
            </p>
            <p>
              【线下展示】
              <br />
              由于疫情原定于<strong>5月核聚变北京站</strong>
              的展出计划将整体延期，目前依然在策划更多线下展示的机会，更多详情将在后续放出。当核聚变2022北京站恢复后，BOOOM在核聚变内的展出计划依然会照常进行。
            </p>
            <p>
              【线上试玩】
              <br />
              后续会举办 BOOOM
              游戏试玩活动，所有玩家均可在网站内玩到你的游戏，详细时间将根据线下展出调整，后续将会公布详情。
            </p>
          </div>

          <div className={styles.flow}>{renderItem(flowImg, flowSmImg)}</div>
          <div className={classnames("text-center", styles.flowTip)}>
            未能到线下参加核聚变的组，游戏将由主办方托管进行线下展示
          </div>
        </div>
      </SideAnimationContainer>
      <SideAnimationContainer direction="right" mount={3000}>
        <div className={styles.container}>
          <Tabs tabs={TABS} render={renderBody} />
        </div>
      </SideAnimationContainer>
    </>
  )
}

export default IndexPage
